import { render, staticRenderFns } from "./ModulePopup.vue?vue&type=template&id=70a7655a&scoped=true"
import script from "./ModulePopup.vue?vue&type=script&lang=js"
export * from "./ModulePopup.vue?vue&type=script&lang=js"
import style0 from "./ModulePopup.vue?vue&type=style&index=0&id=70a7655a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7655a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a7655a')) {
      api.createRecord('70a7655a', component.options)
    } else {
      api.reload('70a7655a', component.options)
    }
    module.hot.accept("./ModulePopup.vue?vue&type=template&id=70a7655a&scoped=true", function () {
      api.rerender('70a7655a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/ModulePopup.vue"
export default component.exports